import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { CartInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-rental-cart-app');
if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    const initData = JSON.parse(mountEl.dataset.reactInit) as CartInitData;
    createRoot(mountEl).render(
        <React.StrictMode>
            <GasQueryProvider>
                <GasToastProvider>
                    <GasConfirmProvider>
                        <App initData={initData} />
                    </GasConfirmProvider>
                </GasToastProvider>
            </GasQueryProvider>
        </React.StrictMode>,
    );
}
